import PropTypes from 'prop-types'
import React, { Component } from 'react'

import BlogPost from './BlogPost/_lazy'
import LoadMore from '../../generic/LoadMore'
import { blogPostsFetchMore } from '../../../redux/modules/blogPosts'
import BlogPostStructure from './BlogPost/propTypes'
import { facebookReparse } from '../../utils/facebookUtils'

import './styles.css'

export class BlogPosts extends Component {
  componentDidMount() {
    facebookReparse()
  }

  render() {
    return (
      <div id="BlogPosts">
        <div className="blog-posts-content">
          {this.props.blogPosts.map((blogPost, idx) => (
            <BlogPost
              key={idx}
              elementName={`posts-${idx}`}
              {...blogPost}
              showSocial={this.props.showSocial}
            />
          ))}
        </div>
        {this.props.next && (
          <div className="load-more">
            <LoadMore
              fetchMoreAction={blogPostsFetchMore}
              next={this.props.next}
            />
          </div>
        )}
      </div>
    )
  }
}

BlogPosts.propTypes = {
  blogPosts: PropTypes.arrayOf(PropTypes.shape(BlogPostStructure)).isRequired,
  showSocial: PropTypes.bool,
  next: PropTypes.string
}

BlogPosts.defaultProps = {
  blogPosts: [],
  showSocial: true,
  next: null
}

export default BlogPosts
